import React from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { RootStateTypeExtra } from '@src/store/types'

import { ConfigInterface } from '@store/actionSlices/projectConfig'
import { NavigationMenuKey, RouteKey } from '@store/constants'

import { ProjectType } from '@utilities/adgroup-utilities/constants/common'
import { hasEnvisionVR, hasSnaploader } from '@utilities/helper'

interface EmptyStateProps {
  projectConfig: ConfigInterface
}

function EmptyState({ projectConfig }: EmptyStateProps) {
  const history = useHistory()
  const {
    threeDViewerUrl,
    snaploaderConfiguration,
    envisionVRConfiguration,
    type,
    navigationSettings,
  } = projectConfig

  const getBuildingLink = React.useCallback((): string => {
    if (projectConfig.showcase3DIntegration) {
      return RouteKey.ADTHREED
    }

    if (type === ProjectType.HouseAndLand) {
      return RouteKey.AREA_VIEW_HOUSE_AND_LAND
    }

    if (hasSnaploader(snaploaderConfiguration)) {
      return RouteKey.SNAPLOADER_VIEW
    }

    if (hasEnvisionVR(envisionVRConfiguration)) {
      return RouteKey.THREE_D_BUILDING
    }

    if (threeDViewerUrl !== '') {
      return RouteKey.AREA_VIEW_3D
    }

    return RouteKey.AREA_VIEW
  }, [snaploaderConfiguration, envisionVRConfiguration, type])

  const exploreLinkText = React.useMemo(() => {
    const dynamicResidencesText = navigationSettings?.find(
      (item) => item.key === NavigationMenuKey.RESIDENCES
    )
    if (dynamicResidencesText && dynamicResidencesText.label) {
      return `Explore ${dynamicResidencesText.label?.toLowerCase()}`
    }

    if (type === ProjectType.HouseAndLand) {
      return 'Explore Precinct'
    }

    return 'Explore Residences'
  }, [navigationSettings])

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <p className="mb-6 text-3xl font-semibold leading-none">
        Your Shortlist is empty
      </p>
      <p className="mb-11 text-[26px] leading-none">
        Add your favourite properties in it.
      </p>
      <button
        type="button"
        className="rounded-lg bg-mainColour px-12 py-5 text-[19px] font-semibold capitalize leading-none text-white"
        onClick={() => history.push(getBuildingLink())}
      >
        {exploreLinkText}
      </button>
    </div>
  )
}

export default connect(({ projectConfig }: RootStateTypeExtra) => ({
  projectConfig,
}))(EmptyState)
